export const durationDisplay = (
  duration: number,
  variant?: 'short' | 'default' | 'long',
) => {
  if (duration < 60) {
    switch (variant) {
      case 'short':
        return `${duration}m`
      case 'long':
        return `${duration} minutes`
      default:
        return `${duration} mins`
    }
  }
  const hours = Math.floor(duration / 60)
  const minutes = duration % 60

  if (minutes > 0) {
    // Has minutes
    switch (variant) {
      case 'short':
        return `${hours}h${minutes}m`
      case 'long':
        return `${hours} hours ${minutes} minutes`
      default:
        return `${hours}hrs ${minutes}mins`
    }
  } else if (hours > 1) {
    switch (variant) {
      case 'short':
        return `${hours}h`
      case 'long':
        return `${hours} hours`
      default:
        return `${hours}hrs`
    }
  } else {
    switch (variant) {
      case 'short':
        return `${hours}h`
      case 'long':
        return `${hours} hour`
      default:
        return `${hours}hr`
    }
  }
}
